let targets = document.querySelectorAll('.product-info-variants__container');

if (!targets.length) return;

export function controlItemsVisibility(target, targetHeight) {

    let pickers = target.querySelectorAll('.product-info-variants__picker');

    pickers.forEach(function (picker, index) {
        let pickerRect = picker.getBoundingClientRect();
        let containerRect = target.getBoundingClientRect();
        let relativePosition = {
            top: pickerRect.top - containerRect.top
        };

        if ((relativePosition.top > targetHeight)) {
            picker.classList.toggle('d-none');
        }
    });


    let hiddenItems = target.querySelectorAll('.product-info-variants__picker.d-none');

    if (hiddenItems.length > 0) {
        target.querySelector('.product-info-variants__picker--see-all')?.classList?.remove('d-none');
        target.querySelector('.product-info-variants__picker--see-all')?.classList?.add('visible');

        //hide last visible element
        let visibleItems = target.querySelectorAll('.product-info-variants__picker.regular-item:not(d-none)');
        if (visibleItems.length) {
            visibleItems[visibleItems.length - hiddenItems.length]?.classList?.add('d-none');
            visibleItems[visibleItems.length - hiddenItems.length - 1]?.classList?.add('d-none');
        }

    }

    target.classList.add('ready');
    updateHeightOfVariantsWrapperEl(target)

}


function runCheck() {
    targets = document.querySelectorAll('.product-info-variants__container');
    targets.forEach(function (target) {


        let targetHeight = target.offsetHeight;
        let productVariantsWrapper = target.querySelector('.product-info-variants__wrapper');
        if (productVariantsWrapper) {
            // Get the height of the product-info-variants__wrapper
            let productVariantsWrapperHeight = productVariantsWrapper.offsetHeight;

            if (targetHeight < productVariantsWrapperHeight) {
                controlItemsVisibility(target, targetHeight);
            } else {
                target.classList.add('ready');
            }
        }
    });
    updateHeightOfVariantsWrapperElMain();
}

function updateHeightOfVariantsWrapperElMain() {
    const variantsWrapperArr = document.querySelectorAll('.product-info-variants__container.ready');
    variantsWrapperArr.forEach(el => {
        updateHeightOfVariantsWrapperEl(el)
    });

};

function updateHeightOfVariantsWrapperEl(el) {
    if (el === null || el === undefined) {
        return;
    }
    const variantContent = el.querySelector('.product-info-variants__container--inner');
    if (variantContent == null) {
        return;
    }
    const variantContentHeight = variantContent.offsetHeight;
    el.style.maxHeight = (parseInt(variantContentHeight) + 32) + 'px';
    const elInner = el.querySelector('.product-info-variants__wrapper');


    if (window.innerWidth < 750) {
        if (elInner.offsetWidth < elInner.scrollWidth) {
            el?.classList.add('mobile_variants-overflown');
            const boundingBox = el.getBoundingClientRect();
            const afterLeftEdge = boundingBox.right - 25;
            el.querySelectorAll('.product-info-variants__wrapper a').forEach(aLink => {
                const afterLeftEdgeWithProductWith = afterLeftEdge;
                const aLinkDimensions = aLink.getBoundingClientRect().right;
                if (aLinkDimensions > afterLeftEdgeWithProductWith) {
                    aLink.classList.add('d-none');
                }

            })

            el.addEventListener('click', function (el2) {

                if (event.clientX >= afterLeftEdge && event.clientX <= boundingBox.right) {

                    const productLinkEl = el?.closest('.product-item__info')?.querySelector('a.product-link');
                    if (productLinkEl === null || productLinkEl === undefined) return;
                    const productLink = productLinkEl.getAttribute('data-product-link');
                    window.location.href = productLink;
                }
            })
        }
    }
}

window.onload = function () {
    if (document.querySelectorAll('.product-info-variants__container.ready').length > 0) {
        setTimeout(() => {
            updateHeightOfVariantsWrapperEl();
        }, 0);
    }

}

window.addEventListener("resize", runCheck);

document.addEventListener("DOMContentLoaded", runCheck);

window.addEventListener("theme:filter:update", runCheck);